import {
    IComponentController,
    IComponentOptions,
    IHttpService,
    IQService,
} from 'angular';
import { IOrderLicense, setAuthorizationHeader } from '../../tn.common';
import { UserService } from '../../tn.user/service.tn.user';

export class TnFontDownloadLink implements IComponentController {
    static $inject = ['$http', '$q', 'apiBaseURl', 'tn.user.service'];
    licenses: IOrderLicense[] = [];
    web: boolean = false;
    downloading: boolean = false;
    constructor(
        protected $http: IHttpService,
        protected $q: IQService,
        protected apiBaseUrl: string,
        protected userService: UserService
    ) {}

    download() {
        console.log('download', this);
        try {
            if (this.downloading) {
                return;
            }
            this.downloading = true;
            const _styleIds = this.licenses.map((l) => l.style.id);
            const distinctStyleIds = new Set(_styleIds);
            const styleIds = Array.from(distinctStyleIds).join(',');
            const url = `${this.apiBaseUrl}/api/1/download?styles=${styleIds}&web=${this.web}`;
            const token = this.userService.accessToken$.value;
            const config = setAuthorizationHeader(token);

            // wrap in $q so ng digest cycle will know about it.
            this.$q
                .when(fetch(url, config))
                .then((response) => {
                    console.log('response', response);
                    if (!response.ok) {
                        console.error('Error downloading font', response);
                        return;
                    }
                    return this.$q.when(response.blob()).then((blob) => {
                        const downloadUrl = window.URL.createObjectURL(blob);

                        console.log('downloadUrl', downloadUrl);
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `TN-${new Date().toISOString()}.zip`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window?.URL.revokeObjectURL(downloadUrl);
                    });
                })
                .catch((error) => {
                    console.error('Error downloading font', error);
                })
                .finally(() => {
                    this.downloading = false;
                });
        } catch (e) {
            console.error(e);
            this.downloading = false;
        }
    }
}

export const TnFontDownloadLinkComponentOptions: IComponentOptions = {
    controller: TnFontDownloadLink,
    template: `
        <a ng-click="$ctrl.download()">
            <ng-transclude ng-hide="$ctrl.downloading"></ng-transclude>
            <span ng-show="$ctrl.downloading">Downloading...</span>
        </a>
    `,
    transclude: true,
    bindings: {
        licenses: '<',
        web: '<?',
    },
};
